export class S3ListPrefixesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "maxResults",
            "baseName": "maxResults",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3ListPrefixesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
